import React, { createContext, PropsWithChildren } from 'react';
import { getAttributionData } from 'services/analytics/analyticsManager';
import {
  logPressableEventFromConfig,
  logScreenEventFromConfig,
  segmentClient,
} from 'services/analytics/segment/segment';
import { SegmentInterface } from 'services/analytics/segment/types';
import { AnalyticsEventsInterface } from 'shared/analytics/types';
import { initializeAnalyticsConfig } from 'shared/providers/analytics/AnalyticsConfig';

export const analyticsConfig = initializeAnalyticsConfig();
interface AnalyticsContextProps {
  segmentClient: SegmentInterface;
  analyticsEvents: AnalyticsEventsInterface;
  attributionData: Record<string, unknown>;
}

/**
 * @deprecated use `useAnalytics` hook instead of consuming this context directly in runtime code. This context is still exported for test backward compatibility, but should not be used in new code.
 */
export const AnalyticsContext = createContext<AnalyticsContextProps>(
  {} as AnalyticsContextProps,
);

// Create analytics events object from exported functions
const analyticsEvents: AnalyticsEventsInterface = {
  logScreenEventFromConfig,
  logPressableEventFromConfig,
};

const CrossPlatformAnalyticsProvider = ({ children }: PropsWithChildren) => {
  // Get attribution data from manager (initialized in Phase 1)
  const attributionData = getAttributionData();

  return (
    <AnalyticsContext.Provider
      value={{
        segmentClient,
        analyticsEvents,
        attributionData,
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};

export default CrossPlatformAnalyticsProvider;
